import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {SubscribeToLcdCreditAnalysisResultModal} from './subscribe-to-lcd-credit-analysis.result.modal';
import {
    clearResult,
    subscribeToLcdCreditAnalysisShownSelector,
    subscribeToLcdCreditAnalysisTaskSelector,
    subscribeToLcdCreditAnalysisUuidSelector,
} from './subscribe-to-lcd-credit-analysis.slice';


export const SubscribeToLcdCreditAnalysisResult = () => (
    <BulkActionResult
        actionIdSelector={subscribeToLcdCreditAnalysisUuidSelector}
        actionTaskSelector={subscribeToLcdCreditAnalysisTaskSelector}
        actionShownSelector={subscribeToLcdCreditAnalysisShownSelector}
        clearResult={clearResult}>
        {({id, onClose}) => <SubscribeToLcdCreditAnalysisResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
